<template>
  <div class="notifications card text-md" id="tpl_kssChamp_popup">
    <div class="cursor-pointer absolute right-5 hover:text-[var(--color-orange)]" id="btn_close">
      <i @click.prevent="deactivate()">
        <font-awesome-icon
          icon="fa-xmark"
        />
      </i>
    </div>
    <div class="text-justify p-5">
      <div class="flex break-words items-start">
        <font-awesome-icon
          class="w-12 h-12"
          v-if="notification.content.icon"
          :icon="notification.content.icon"
        ></font-awesome-icon>
        <h3 v-if="notification.content.header && notification.content.header[lang]" class="pl-3">
          <span id="txt_kssChampionNotificationHeader">
            {{ notification.content.header[lang] }}
          </span>
        </h3>
      </div>
      <div v-if="notification.content.text && notification.content.text[lang]"
       class="flex break-normal">
        <h4 id="tpl_kss_champion_popup_h3" class="break-normal">
          {{ notification.content.text[lang] }}
        </h4>
      </div>
    </div>
    <div class="flex justify-end">
      <a
        v-if="notification.content.tenantUrl &&
         notification.content.positiveButton && notification.content.positiveButton[lang]"
        :href="notification.content.tenantUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="block mr-5 ml-auto mt-4 py-3 px-9 rounded-full
         text-lg bg-[var(--color-orange)] text-center text-inherit no-underline"
        name="regist"
        id="btn_regist"
      >{{ notification.content.positiveButton[lang] }}</a>
      <button
        v-else-if="notification.content.positiveButton && notification.content.positiveButton[lang]"
        type="submit"
        class="block  mr-5 ml-auto mt-4 py-3 px-9 rounded-full text-lg bg-[var(--color-orange)]"
        name="regist"
        id="btn_regist"
        v-html="notification.content.positiveButton[lang]"
      ></button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GenericTaskNotificationComponent',
  props: ['notification'],
  computed: {
    lang() {
      // Add null check and fallback for i18n
      return this.$i18n?.locale || 'en';
    },
  },
  methods: {
    deactivate() {
      this.$store.dispatch('deactivatePopUp', this.notification._id);
    },
  },
};
</script>
